import React, { useEffect, useState,  createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';
 
import NormalDetails from './NormalDetails';

import UserManagementApi from '../../../Classes/API/Administration/UserManagementApi';
import SearchStringOrIntReq from "Classes/Models/Requests/SearchStringOrIntReq"

import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes"

import { useContext } from 'react';
import { UserContext } from 'App';


export const SelectedUserContext = createContext();

const index = () => {
    const { state } = useLocation();

    const CurrentUser = useContext(UserContext);

    const [SelectedUser, setSelectedUser] = useState({})

    let userTypes =  new UserTypes();

    let req = new SearchStringOrIntReq()

    useEffect(async () => {
        if (Object.keys(SelectedUser) < 1) {
            await GetUserData(state.SearchUser.id)
        }

    }, [])
 

    const GetUserData = async (id) => {
        req.searchInt = id;
        let res = await UserManagementApi.GetUserById(req)
        if (res.status == "Success") {
            // let metadataClone  = Object.assign({}, res.data)
            console.log(res.data)
            setSelectedUser(res.data)
        }
    }

    const RouteToUserType = () => {

        if (SelectedUser.userType == userTypes.UnAssigned) {
            console.log("UserDetails:", SelectedUser)
            return (

                <NormalDetails GetUserData={GetUserData}  />
            )
        }


        if (SelectedUser.userType == userTypes.Patient) {
            return (
                <>
                <NormalDetails GetUserData={GetUserData} />
                </>

            )
        }

        
        if (SelectedUser.userType == userTypes.Therapist
            || SelectedUser.userType == userTypes.AssessmentTherapist) {
            return (
                <>
                <NormalDetails GetUserData={GetUserData} />
                </>

            )
        }
      
        if (SelectedUser.userType == userTypes.Admin
            || SelectedUser.userType == userTypes.AppointmentEmployee
            || SelectedUser.userType == userTypes.AccountingEmployee
                || SelectedUser.userType == userTypes.FloorManager) {
            return (
                <>
                <NormalDetails GetUserData={GetUserData} />
                </>

            )
        }
       
    }

    return (

        <DashboardLayout>
            <DashboardNavbar />
            <SelectedUserContext.Provider value={SelectedUser}>
            {RouteToUserType()}
            </SelectedUserContext.Provider>

        </DashboardLayout>

    )
}

export default index